import * as yup from 'yup';
export const devicePortalSchema = yup.object().camelCase().shape({
    id: yup.string().required(),
    slug: yup.string().required(),
    name: yup.string().required(),
    description: yup.string().nullable().ensure(),
    loginUrl: yup.string().required(),
    logo: yup.string().nullable().ensure(),
});
